import React from 'react';

function Footer() {
    return(
    <div className="fixed  w-full px-8 py-8 bottom-0" >
        <div class=" w-full inline-flex justify-center rounded border-2 border-black px-1 py-1 bg-[var(--nav-footer)]">
            <div class="flex justify-center align-center items-center buttonName h-9">
                <p className='text-sm sm:text-base text-center font-bold'>Copyright &copy; 2024 Photic23. All Rights Reserved</p>
            </div>
            <div class="items-center inline-flex">

            </div>
        </div>
    </div>        
    );
}

export default Footer;